<template>
  <div class="expire-statistical" v-if="expireSabbatical.length> 0">
    <SabbaticalItems v-for="(item, index) in expireSabbatical" :key="index" :sabbaticalInfo="item"/>
  </div>
  <div v-else class="expire-statistical">{{$t("fields.sabbatical.sabbatical_expiring_leave")}}</div>
</template>
<script>
import { mapGetters } from "vuex";
import SabbaticalItems from "./SabbaticalItems.vue";
export default {
  name: "ExpireSabbatical",
  data() {
    return {};
  },
  components: {
    SabbaticalItems,
  },
  computed: {
    ...mapGetters({
      expireSabbatical: "sabbatical-leave-request/expireSabbatical",
    }),
  },
  methods: {
    async initial() {
      await this.getExpireSabbatical();
    },
    async getExpireSabbatical() {
      let sabbaticalRequestId = this.$route.params.id;
      await this.$store.dispatch("sabbatical-leave-request/getExpireSabbatical",sabbaticalRequestId);
    }
  },
  created() {
    this.initial()
  },
};
</script>
<style lang="scss" scoped>
.expire-statistical {
  padding: 15px 0 5px;
}
</style>
